import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from '../app.service';
import { LoaderService } from '../loader/loader.service';

@Component({
  templateUrl: './tagcloud.component.html',
  styleUrls: ['./tagcloud.component.css'],
  providers: [AppService, LoaderService]
})
export class TagCloudComponent implements OnInit {
  error: String;

	constructor(
		private appService: AppService,
		private loaderService: LoaderService
	) {}

	ngOnInit() {}

	onSubmitTagCloud(countWordsForm: NgForm) {
    if(!countWordsForm.value.countWords) {
      alert('Vous ne pouvez pas laisser de champ(s) vide(s)')
    } else {
      this.error = '';
      this.loaderService.show();
      this.appService.sendTagCloud({
        wordCount: countWordsForm.value.countWords
      })
       .subscribe((res) => {
         console.log("res:", res);
         this.loaderService.hide();
       }, (err) => {
         this.loaderService.hide();
         this.error = err;
       });
     }
	}
}



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/tagcloud/tagcloud.component.ts